import { useContext } from 'react';
import { IncaContext } from '../components/ScopedIncaContext/IncaContext';
export const useInca = ()=>{
    const ctx = useContext(IncaContext);
    if (!ctx) {
        throw new Error('IncaReactContext is not set!');
    }
    return ctx;
};
export const useIncaForm = ()=>{
    const ctx = useInca();
    if (ctx.type !== 'form') {
        throw new Error(`Incorrect IncaReactContext. Expected type "form" but got "${ctx.type}"`);
    }
    return ctx;
};
export const useIncaStartPage = ()=>{
    const ctx = useInca();
    if (ctx.type !== 'startpage') {
        throw new Error(`Incorrect IncaReactContext. Expected type "startpage" but got "${ctx.type}"`);
    }
    return ctx;
};
export const useIncaCustomPage = ()=>{
    const ctx = useInca();
    if (ctx.type !== 'custompage') {
        throw new Error(`Incorrect IncaReactContext. Expected type "custompage" but got "${ctx.type}"`);
    }
    return ctx;
};
